<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 15:57:14
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-10-09 14:22:08
 * @name: 部门人员表格
 * @Description: 部门人员表格
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\people-table.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="peopleTable">
    <el-row>
      <el-col :span="12">
        <el-input v-model="keyword" placeholder="请输入姓名查询...">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="keywordSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <table-normal>
      <template v-slot:title>
        <div class="title">
          <font>部门人员</font>
        </div>
      </template>
      <template v-slot:head>
        <div class="head">
          <el-button size="mini" plain @click="add">添加成员</el-button>
          <el-button
            size="mini"
            plain
            @click="update"
            :disabled="user_ids.length === 0"
            >调整部门</el-button
          >
          <el-button
            size="mini"
            plain
            @click="del"
            :disabled="user_ids.length === 0"
            >批量离职</el-button
          >
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="tableData"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55">
          </el-table-column>
          <el-table-column align="center" prop="realname" label="姓名">
          </el-table-column>
          <el-table-column align="center" prop="role_text" label="职位">
          </el-table-column>
          <el-table-column align="center" prop="mobile" label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="editClickHandler(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="bindErp(scope.row)"
                v-if="!scope.row.erp_user_id"
                >绑定Erp</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="total"
        ></Pagination>
      </template>
    </table-normal>
    <addNedit-people
      :mailList="mailList"
      ref="addNedit"
      @updateHandler="updateHandler"
    >
    </addNedit-people>
    <edit-people :mailList="mailList" ref="edit" @updateHandler="updateHandler">
    </edit-people>
    <update-department
      :mailList="mailList"
      ref="update"
      @confirm="confirm"
    ></update-department>
    <!-- 多选,改为单选了 -->
    <!-- <adjust-department :mailList="mailList" ref="update" @confirm="confirm">
    </adjust-department> -->
    <erp-bind ref="erpBind" @confirm="erpBindConfirm"></erp-bind>
  </div>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";
import addNeditPeople from "./dialog/addNedit-people.vue";
import editPeople from "./dialog/edit-people.vue";
import updateDepartment from "./dialog/update-department.vue";
import { confirmation, debounceation } from "@/utils/decorator";
// 多选,改为单选了
// import adjustDepartment from "./dialog/adjust-department.vue";
import { setErpUser } from "@/api/mailList/mailList.api";
import erpBind from "./dialog/erp-bind";
export default {
  name: "mailList-Content-peopleTable",
  components: {
    tableNormal,
    addNeditPeople,
    editPeople,
    updateDepartment,
    // 多选,改为单选了
    // adjustDepartment,
    erpBind,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      user_ids: [], //选中的人员数组
      keyword: "", //模糊查询
      pagination: {
        page: 1,
        limit: 10,
      },
    };
  },
  computed: {
    // 表格是否加载中
    loading() {
      return (
        this.mailList.peopleDataLoading.find(
          (x) => x.id === this.mailList.treeNode.id
        )?.loading ?? false
      );
    },
    // 表格数据总量
    total() {
      return (
        this.mailList.peopleData.find((x) => x.id === this.mailList.treeNode.id)
          ?.dataCount ?? 0
      );
    },
    // 表格数据内容
    tableData() {
      return (
        this.mailList.peopleData.find((x) => x.id === this.mailList.treeNode.id)
          ?.list ?? []
      );
    },
  },
  watch: {
    // 激活的部门id变化,更新人员表格数据
    "mailList.treeNode.id": {
      handler(nv, ov) {
        if (nv !== ov) {
          this.keyword = "";
          this.mailList.peopleData = [];
          this.pagination = {
            page: 1,
            limit: 10,
          };
        }
      },
      immediate: true,
      deep: true,
    },
    // 分页器信息变化,更新人员表格数据
    pagination: {
      handler(nv, ov) {
        let id = this.mailList.treeNode.id;
        this.getPeopleList(id);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 姓名模糊查询
     */
    @debounceation(300)
    keywordSearch() {
      this.mailList.peopleData = [];
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择人员
     * @param {Array} val 选中项
     */
    handleSelectionChange(val) {
      this.user_ids = val;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击表格行操作图标
     * @param {Object} row 表格行数据
     */
    @debounceation(300)
    settingClickHandler(row) {
      this.$refs.edit.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取部门人员表格数据
     * @param {String | Number} id 激活节点id
     */
    getPeopleList(id) {
      let params = { keyword: this.keyword, ...this.pagination };
      params.id = id;
      this.mailList.getPeople(params);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加人员
     */
    @debounceation(300)
    add() {
      this.$refs.addNedit.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑人员
     */
    @debounceation(300)
    editClickHandler(row) {
      this.$refs.addNedit.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 调整部门
     */
    @debounceation(300)
    update() {
      this.$refs.update.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 批量删除
     */
    @confirmation("确认批量删除?")
    del() {
      this.mailList
        .delPeople({ user_ids: this.user_ids.map((x) => x.id) })
        .then((res) => {
          this.updateHandler(); //数据发生变化，更新表格
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 数据变更,获取新数据
     */
    updateHandler() {
      let params = { ...this.pagination };
      params.id = this.mailList.treeNode.id;
      this.mailList.getPeople(params); //获取人员表格新数据
      this.mailList.getTreeList(); //获取新的树结构
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 确认调整部门
     * @param {Array} arr 调整到部门数组
     */
    @debounceation(300)
    confirm(department_id) {
      let user_ids = this.user_ids.map((x) => x.id);
      this.mailList
        .jurisdictionPeople({ user_ids, department_id })
        .then((res) => {
          this.updateHandler(); //数据发生变化，更新表格
          this.$refs.update.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 绑定erp
     */
    @debounceation(300)
    bindErp(row) {
      this.$refs.erpBind.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: erp绑定确认
     */
    erpBindConfirm(e) {
      setErpUser({
        id: e?.user_id ?? "",
        erp_user_id: e.erp?.id ?? "",
      }).then((res) => {
        this.$message.success("绑定成功!");
        this.getPeopleList();
        this.$refs.erpBind.cancel();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.peopleTable {
  width: 100%;
}
</style>